import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';
import Leaf from '../../../../Assets/StorefrontIcons/Leaf.svg';

function Box({ title }) {
    return (
        <div className="w-full flex flex-col items-center justify-between">
            <div className="size-4">
                <img src={Leaf} alt="" />
            </div>

            <p className='font-semibold text-[10px] leading-[18px] text-[#121212]'>{title}</p>
        </div>
    )
}

function FeaturesTwo() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`FEATURES_TWO${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl outline-none select-none">
            <div className="w-full h-[100px] flex gap-2 rounded-md bg-[#EAEAEA] p-2">
                <div className="w-full grid grid-cols-2 grid-rows-2 gap-x-3 gap-y-3">
                    <Box title='Eco-friendly' />

                    <Box title='Sustainable' />

                    <Box title='Fashion Forward' />

                    <Box title='Advanced Tech' />
                </div>
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>Features 2</p>
        </button>
    );
}

export default FeaturesTwo;
